import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const SearchResultTitle = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 20px !important;
  }
  h1 {
    flex-basis: auto;
    font-family: 'Open Sans', sans-serif;
    color: #4a4a4a;
    font-size: 28px;
    margin-bottom: 13px;
    margin-top: 0;
  }
  span {
    margin-right: 20px;
  }
`

export default SearchResultTitle
